<po-page-default>
    <app-welcome></app-welcome>
    <app-breadcrumb></app-breadcrumb>
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 informative">
      <div class="p-row">
        <po-widget class="po-lg-3 po-md-3 po-sm-6 po-mt-2" p-title="Total de vendas">
          <div class="po-font-subtitle po-text-center">
            <span class="po-font-text-small">R$</span>
            <span>{{itemTotalSplit}}</span>
          </div>
          <div class="po-font-subtitle po-text-center margin-bottom-10">
            <span class="po-font-text-small">Ano anterior</span>
            <span class="po-font-text-large-bold"> 
              <span *ngIf="itemTotalLastYear < 0" class="po-icon po-icon-arrow-down" style="color: 'red'; margin-left: 10px;"></span><span *ngIf="itemTotalLastYear > 0" class="po-icon po-icon-arrow-up" style="color: 'green'; margin-left: 10px;"></span> {{itemTotalLastYear}}%
            </span>
          </div>
        </po-widget>
        <po-widget class="po-lg-3 po-md-3 po-sm-6 po-mt-2" p-title="Ticket médio">
          <div class="po-font-subtitle po-text-center">
            <span class="po-font-text-small">R$</span>
            <span>{{itemTmSplit}}</span>
          </div>
          <div class="po-font-subtitle po-text-center margin-bottom-10">
            <span class="po-font-text-small">Ano anterior</span>
            <span class="po-font-text-large-bold"> 
              <span *ngIf="itemTmLastYear < 0" class="po-icon po-icon-arrow-down" style="color: 'red'; margin-left: 10px;"></span><span *ngIf="itemTmLastYear > 0" class="po-icon po-icon-arrow-up" style="color: 'green'; margin-left: 10px;"></span> {{itemTmLastYear}}%
            </span>
          </div>
        </po-widget>
        <po-widget class="po-lg-3 po-md-3 po-sm-6 po-mt-2" p-title="PMPV">
          <div class="po-font-subtitle po-text-center">
            <span class="po-font-text-small">R$</span>
            <span>{{itemPmpvSplit}}</span>
          </div>
          <div class="po-font-subtitle po-text-center margin-bottom-10">
            <span class="po-font-text-small">Ano anterior</span>
            <span class="po-font-text-large-bold"> 
              <span *ngIf="itemPmpvLastYear < 0" class="po-icon po-icon-arrow-down" style="color: 'red'; margin-left: 10px;"></span><span *ngIf="itemPmpvLastYear > 0" class="po-icon po-icon-arrow-up" style="color: 'green'; margin-left: 10px;"></span> {{itemPmpvLastYear}}%
            </span>
          </div>
        </po-widget>
        <po-widget class="po-lg-3 po-md-3 po-sm-6 po-mt-2" p-title="PA">
          <div class="po-font-subtitle po-text-center">
            <span>{{itemPa}}</span>
          </div>
          <div class="po-font-subtitle po-text-center margin-bottom-10">
            <span class="po-font-text-small">Ano anterior</span>
            <span class="po-font-text-large-bold"> 
              <span *ngIf="itemPaLastYear < 0" class="po-icon po-icon-arrow-down" style="color: 'red'; margin-left: 10px;"></span><span *ngIf="itemPaLastYear > 0" class="po-icon po-icon-arrow-up" style="color: 'green'; margin-left: 10px;"></span> {{itemPaLastYear}}%
            </span>
          </div>
        </po-widget>
      </div>
    </div>
  
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 sales-group">
      <po-widget>
        <div class="po-row">
          <div class="po-xl-7 po-lg-7 po-md-7 po-sm-7">
            <span class="po-font-text-bold ">Venda por vendedores</span>
            <span class="po-ml-1 po-icon po-icon-xml pointer-cursor" [p-tooltip]="topTooltipExcel"
              (click)="downloadExcel()"></span>
          </div>
        </div>
        <div *ngIf="!errorApi">
          <po-table [p-items]="tableRanking" [p-actions]="actions" [p-sort]="true" [p-loading]="loading"
            [p-striped]="true"></po-table>
        </div>
        <div class="po-text-center po-pt-5" *ngIf="errorApi">
          <app-error [message]="message"></app-error>
        </div>
      </po-widget>
    </div>
  </po-page-default>